import React from 'react'
import './styles.scss';

const GradientButton = ({ legend, handleClick, type = 'button', disabled = false, className = '', title }) => {
    const combinedClassName = `gradient-button ${className}`.trim();

    return <input type={type} className={combinedClassName} value={legend} onClick={handleClick} disabled={disabled} title={title} />
}

export default GradientButton;